import React from 'react'
import styled from 'styled-components'

const ContainerInput = styled.div<{ background: string, className: string }>`
    background: ${p => p.background};
    display: flex;
    justity-content: center;
    flex-direction: row;
    padding: 6px;
    border-radius: 5px;
    margin: 6px 4px;
    height: 50px;
    width: 98%;
    position: relative;
    
    .css-1pahdxg-control:hover {
        border-color: white;
    }

    > div div {
        border: 0;
        
        > div:nth-child(2) div,
        > div:nth-child(2) span {
            display: none;
        }
    }

    > div {
        min-width: 15px;
        margin-left: 5px;
        margin-right: 5px;
        align-self: center;
    }

    > div svg{
        color: ${p => p.theme.palette.primary.main};
    }

    > select {
        width: 100%;
        outline: none;
        border: none;
        background: ${p => p.background};
        padding:2px;
        color: ${p => p.theme.palette.text.gray}
    }

    ${p => p.className}
`
const ContainerOptions = styled.section<{ show: boolean }>`
    position: absolute;
    top: 35px;
    width: 90%;
    background: white;
    left: 0;
    right: 0;
    margin: auto;
    max-height: 120px;
    overflow: auto;
    border-radius: 10px;
    z-index: 3;
    display: ${p => p.show ? 'block' : 'none'};

    > div {
        padding: 5px;
        transition: .3s;
        cursor: pointer;
        color: black;
        font-weight: 100;

        :hover {
            background: ${p => p.theme.palette.secondary.main};
        }

        :nth-child(1) {
            background: grey;
            opacity: 0.5;
            cursor: none;
            color: white;
        }
    }

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #dadada;
        border-radius: 10px;
    }
    
    ::-webkit-scrollbar-thumb {
        background: ${p => p.theme.palette.secondary.main};
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #b30000; 
    }
`

const CustomInput = styled.input<{ background: string }>`
    background: ${p => p.background};
    width: 100%;
    outline: none;
    border: none;
`

interface IOwnProps{
    selectRef?: any;
    textHolder: string;
    className?: string;
    icon?: React.ReactElement;
    background?: string;
    listOptions?: string[];
}

const SelectTC: React.FunctionComponent<IOwnProps> = ({
    selectRef,
    icon,
    textHolder,
    className = '',
    background = '#F2F2F2',
    listOptions = []
}) => {
    const [value, setValue] = React.useState('')
    const [show, setShow] = React.useState(false)
    const [move, setMove] = React.useState(false)

    const handleValue = (option: string) => () => {
        setValue(option)
        setShow(false)
    }

  return (
    <ContainerInput className={className} background={background}>
        {!!icon && <div>{icon}</div>}
        <CustomInput
            type='text'
            background={background}
            placeholder={textHolder}
            value={value}
            onFocus={() => setShow(true)}
            onBlur={() => move ? setShow(true) : setShow(false)}
            readOnly
        />
        <ContainerOptions show={show}>
            <div>{textHolder}</div>
            {listOptions.map(option => (
                <div
                    onClick={handleValue(option)}
                    onMouseOver={() => setMove(true)}
                    onMouseOut={() => setMove(false)}
                >
                    {option}
                </div>
            ))}
        </ContainerOptions>
    </ContainerInput>
  )
}

export default SelectTC